export function makeEnvKey({ spaceId, envId }) {
  return `${spaceId}:${envId}`;
}



// WEBPACK FOOTER //
// ./src/javascripts/ReduxAppActions/statePersistence/helpers.es6.js